module.exports = __webpack_public_path__ + "img/ic-esthetique.91823c09.svg";